import { theme } from '../theme'
import { IDimensions } from '../utils/Canvas'

export default function drawDiagonalLines(
  ctx: CanvasRenderingContext2D,
  constants: IDimensions,
  x: number,
  y: number,
  w: number,
  h: number,
) {
  ctx.strokeStyle = theme.colors.calendar.gridBorder
  ctx.lineWidth = constants.GRID_DIAGONAL_LINE_WIDTH
  ctx.lineCap = 'round'
  ctx.beginPath()
  let currentPositionY = y - w
  while (currentPositionY <= h + w) {
    ctx.moveTo(x, currentPositionY)
    ctx.lineTo(x + w, currentPositionY - w)
    currentPositionY +=
      constants.GRID_DIAGONAL_LINE_SPACING +
      constants.GRID_DIAGONAL_LINE_THICKNESS
  }
  ctx.stroke()
}
